import { Controller } from "@hotwired/stimulus"

// Zakładki logowanie/rejestracja (czysto klienckie przełączanie paneli).
// data-tab na przyciskach i panelach wiąże je ze sobą.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { default: String }

  connect() { this.#activate(this.defaultValue || this.tabTargets[0]?.dataset.tab) }

  select(event) { this.#activate(event.currentTarget.dataset.tab) }

  #activate(name) {
    this.tabTargets.forEach(t => t.classList.toggle("is-active", t.dataset.tab === name))
    this.panelTargets.forEach(p => { p.hidden = p.dataset.tab !== name })
  }
}
